import {
  ChildElement,
  PrecheckResponse,
  PrecheckState,
  RequestState,
  RootValidation,
  ValidationGroup,
  ValidationItem,
  ValidationStatus,
  sortOrder
} from 'vrlcm-gui-types';

function toValidationItem(
  requestState: RequestState,
  elm: ChildElement,
  component: string
): ValidationItem {
  let status: ValidationStatus;

  if (!elm.status) {
    status =
      requestState === 'FAILED' || requestState === 'COMPLETED'
        ? 'SKIPPED'
        : 'PENDING';
  } else {
    status =
      elm.status === 'FAILED' && elm.checkType === 'WARNING'
        ? elm.id && elm.id.includes('user_ok')
          ? 'USER_WARNING'
          : 'WARNING'
        : elm.status === 'FAILED' && elm.checkType === 'ERROR'
        ? 'FAILED'
        : 'PASSED';
  }

  return {
    name: elm.checkName,
    component,
    recommendations: elm.recommendations,
    result: elm.resultDescription,
    status
  };
}

export function toValidationItemsFromChildElement(
  requestState: RequestState,
  elm: ChildElement,
  component: string
): ValidationItem[] {
  if (!elm.childElements) {
    return [toValidationItem(requestState, elm, component)];
  } else {
    return elm.childElements.reduce((acc: ValidationItem[], cur) => {
      return [
        ...acc,
        ...toValidationItemsFromChildElement(requestState, cur, elm.checkName)
      ];
    }, []);
  }
}

/**
 * Crude data sanitazion effort
 * @param items
 * @param requestState
 */
function getDerivedValidationStatus(
  items: ValidationItem[],
  requestState: RequestState
): ValidationStatus {
  if (items.some(({ status }) => status === 'FAILED')) {
    return 'FAILED';
  } else if (
    items.every(
      ({ status }) =>
        status === 'PASSED' ||
        status === 'FIXED' ||
        status === 'WARNING' ||
        status === 'USER_WARNING'
    )
  ) {
    return 'PASSED';
  } else if (requestState === 'FAILED' || requestState === 'COMPLETED') {
    return 'SKIPPED';
  } else {
    return 'PENDING';
  }
}

function getRootValidationStatus(
  requestState: RequestState,
  items: ValidationItem[]
): ValidationStatus {
  return getDerivedValidationStatus(items, requestState);
}

export const toPrecheckValidationGroup = (requestState: RequestState) => {
  return (rootValidation: RootValidation): ValidationGroup => {
    const {
      checkName: name,
      childElements: rootChildElements
    } = rootValidation;

    const items = rootChildElements
      ? rootChildElements.reduce((acc: ValidationItem[], elm) => {
          return [
            ...acc,
            ...toValidationItemsFromChildElement(
              requestState,
              elm,
              elm.checkName
            )
          ];
        }, [])
      : [];

    items.sort((a, b) => {
      return sortOrder.indexOf(a.status) - sortOrder.indexOf(b.status);
    });

    return {
      name,
      status: getRootValidationStatus(requestState, items),
      items
    };
  };
};

export function toPrecheckState(response: PrecheckResponse): PrecheckState {
  const {
    rootValidations,
    requestState,
    lastUpdateTimeMillis,
    overallStatus
  } = response;
  const groups = rootValidations.map(toPrecheckValidationGroup(requestState));
  return { groups, lastUpdateTimeMillis, requestState, overallStatus };
}

export function downloadReportLazy(state: PrecheckState, reportTitle?: string) {
  // @ts-ignore
  import('./pdf-utils').then(({ downloadReport }) => {
    downloadReport(state, reportTitle);
  });
}
